(() => {
  if (window.stReviewInvitationInstalled) return;
  window.stReviewInvitationInstalled = true;
  let timer;
  function openReview() {
    clearInterval(timer);
    let attempts = 0;
    const tryOpen = () => {
      const frame = document.querySelector('iframe.main-widget-product');
      let button;
      try { button = frame?.contentDocument?.querySelector('button.write-review-button'); } catch (_) {}
      if (button) {
        clearInterval(timer);
        frame.scrollIntoView({block: 'start', behavior: 'auto'});
        if (button.getAttribute('aria-expanded') !== 'true') button.click();
        return true;
      }
      if (++attempts >= 60) {
        clearInterval(timer);
        frame?.scrollIntoView({block: 'start', behavior: 'auto'});
      }
      return false;
    };
    if (!tryOpen()) timer = setInterval(tryOpen, 250);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-st-write-review]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (new URL(link.href).pathname !== location.pathname) return;
    event.preventDefault();
    history.replaceState(null, '', '#write-review');
    openReview();
  });
  if (location.hash === '#write-review') openReview();
})();
